module.exports = __webpack_public_path__ + "static/saasvisitor1-b9cba2f34d3bbe5f6d201828af44bfbe.png";